export default "__VITE_ASSET__CcdKT_Hp__"